import Breadcrumb from "../Component/Breadcrumb";

function About() {
  return (
    <>
      <Breadcrumb>About / Our School</Breadcrumb>
      <div className="innersec about_sec">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>About</h1>
            </div>
            <div className="col-md-8">
              <p className="about-text">
                <b>ST. JOSEPH’S SCHOOL, BARHALGANJ,</b> AFFILIATED TO THE CENTRAL BOARD OF SECONDARY EDUCATION, NEW DELHI (AFF. NO. 2131498) IS AN ENGLISH MEDIUM CHRISTIAN MINORITY EDUCATIONAL INSTITUTION ESTABLISHED IN 2007, ADMINISTERED AND GOVERNED BY THE CATHOLIC DIOCESE OF GORAKHPUR EDUCATION SOCIETY, REGISTERED UNDER THE SOCIETY'S REGISTRATION ACT.<br />
                BEING GOVERNED BY THE CATHOLIC CHURCH A MINORITY COMMUNITY, THE SCHOOL HAS THE PRIMARY OBJECTIVE OF EDUCATING THE CHILDREN OF THE COMMUNITY. HOWEVER, WE SHALL NOT SPARE ANY EFFORT IN RENDERING OUR SERVICE TO ALL PEOPLE, IRRESPECTIVE OF CASTE AND GENDER, SO AS TO CONSERVE THEIR RELIGION, LANGUAGE AND CULTURE.
              </p>
            </div>
            <div className="col-md-4 mb-3">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/slider1.png"
                className="img-fluid rounded"
                alt="School"
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default About;